var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-box" },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [_vm._v(_vm._s(_vm.getPropItems))]
      ),
      _c(
        "div",
        {
          staticClass: "container-head fx",
          style: { padding: _vm.selectWidth == 46 ? "15px 30px" : "15px 8px" },
        },
        [
          _c("div", { staticClass: "container-head-left" }, [
            _c("span", { staticClass: "unlf" }, [
              _c("img", {
                staticClass: "imgIcon",
                attrs: {
                  src: require("@/assets/gbIcon/comtc_icon.png"),
                  alt: "",
                },
              }),
              _c("span", { on: { click: _vm.titleHandle } }, [
                _vm._v(_vm._s(_vm.propItems.companyName)),
              ]),
            ]),
            _vm.propItems.regStatus
              ? _c("span", { staticClass: "tags" }, [
                  _vm._v(_vm._s(_vm.propItems.regStatus)),
                ])
              : _vm._e(),
            _c("div", {
              class: ["bg", { unstar: !_vm.propItems.star }],
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleStarB.apply(null, arguments)
                },
              },
            }),
            _c("div", { staticClass: "unlock-time" }, [
              _vm._v(" 解锁时间：" + _vm._s(_vm.propItems.createTime) + " "),
            ]),
          ]),
          _vm.type !== 3 &&
          _vm.propItems.infoList.some(function (e) {
            return e.isTurnClue == 0 || e.isTurnClue == null
          })
            ? _c(
                "div",
                {
                  staticClass: "container-head-right recycle mr-16",
                  on: { click: _vm.removeCompanyToTrash },
                },
                [
                  _c("i", { staticClass: "iconfont icon-huishouzhan" }),
                  _vm._v(" 回收站 "),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.propItems.infoList && _vm.propItems.infoList.length > 0,
                  expression: "propItems.infoList&&propItems.infoList.length>0",
                },
              ],
              staticClass: "container-head-right zk",
              on: {
                click: function ($event) {
                  return _vm.clickChange(_vm.propItems)
                },
              },
            },
            [
              _vm._v(" " + _vm._s(_vm.propItems.collapse ? "收起" : "展开")),
              _c("i", {
                class: _vm.propItems.collapse
                  ? "el-icon-arrow-up"
                  : "el-icon-arrow-down",
              }),
            ]
          ),
        ]
      ),
      _c(
        "el-table",
        {
          staticClass: "table-content",
          class:
            _vm.propItems.collapse &&
            _vm.propItems.infoList &&
            _vm.propItems.infoList.length > 0
              ? "height-anima-open"
              : "height-anima-close",
          attrs: {
            "row-key": "cid",
            data: _vm.propItems.infoList,
            "header-cell-style": { background: "#F7F7FA" },
            "cell-class-name": _vm.addClass,
          },
        },
        [
          _c("el-table-column", {
            attrs: { width: _vm.selectWidth },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c("el-checkbox", {
                      on: {
                        change: function ($event) {
                          return _vm.changeAll()
                        },
                      },
                      model: {
                        value: _vm.checkAll,
                        callback: function ($$v) {
                          _vm.checkAll = $$v
                        },
                        expression: "checkAll",
                      },
                    }),
                  ]
                },
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-checkbox", {
                      on: {
                        change: function ($event) {
                          return _vm.changeOne(
                            scope.row,
                            _vm.propItems.estiblishTime
                          )
                        },
                      },
                      model: {
                        value: scope.row.checked,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "checked", $$v)
                        },
                        expression: "scope.row.checked",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "联系方式来源" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.sources && scope.row.sources.length === 1
                      ? _c("span", [
                          scope.row.sources[0].sourceHref
                            ? _c(
                                "a",
                                {
                                  staticClass: "underline fontSize hover",
                                  attrs: {
                                    rel: "noopener noreferrer",
                                    href: scope.row.sources[0].sourceHref,
                                    target: "about",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.sources[0].source))]
                              )
                            : _c("span", { staticClass: "fontSize" }, [
                                _vm._v(_vm._s(scope.row.sources[0].source)),
                              ]),
                        ])
                      : _vm._e(),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              scope.row.sources && scope.row.sources.length > 1,
                            expression:
                              "scope.row.sources&&scope.row.sources.length>1",
                          },
                        ],
                      },
                      [_vm._v(_vm._s(scope.row.sources[0].source) + "...")]
                    ),
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          width: "200",
                          trigger: "click",
                          "popper-class": "popoverTable",
                        },
                      },
                      [
                        _vm._l(scope.row.sources, function (s, index) {
                          return scope.row.sources && scope.row.sources.length
                            ? _c("div", { key: index }, [
                                s.sourceHref
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "underline source hover",
                                        attrs: {
                                          rel: "noopener noreferrer",
                                          href: s.sourceHref,
                                          title: s.source,
                                          target: "about",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.quan,
                                            alt: "",
                                            srcset: "",
                                          },
                                        }),
                                        _vm._v(_vm._s(s.source)),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "nohands source",
                                        attrs: { title: s.source },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.quan,
                                            alt: "",
                                            srcset: "",
                                          },
                                        }),
                                        _vm._v(_vm._s(s.source)),
                                      ]
                                    ),
                              ])
                            : _vm._e()
                        }),
                        _c(
                          "el-link",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  scope.row.sources &&
                                  scope.row.sources.length > 1,
                                expression:
                                  "scope.row.sources&&scope.row.sources.length>1",
                              },
                            ],
                            attrs: { slot: "reference", type: "primary" },
                            slot: "reference",
                          },
                          [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  scope.row.sources && scope.row.sources.length
                                ) +
                                ")"
                            ),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "联系人",
              prop: "contactName",
              width: _vm.contactNameWidthFlag ? "72" : "78",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row.contactName || "-") + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "联系方式", prop: "content" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        class: _vm.lableLine(scope.row.label)
                          ? "line-through"
                          : "",
                      },
                      [
                        _vm._v(" " + _vm._s(scope.row.content)),
                        _c(
                          "i",
                          {
                            staticClass: "el-icon-document-copy copy-icon",
                            on: {
                              click: function ($event) {
                                return _vm.copyName(scope.row)
                              },
                            },
                          },
                          [_vm._v("复制")]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "备注",
              prop: "content",
              width: _vm.contactNameWidthFlag ? "230" : "390",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  var $index = ref.$index
                  return [
                    _c(
                      "div",
                      { staticClass: "label-content" },
                      [
                        _c(
                          "div",
                          { staticClass: "label" },
                          [
                            !_vm.hasLabel(row.label)
                              ? [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        trigger: "hover",
                                        effect: "light",
                                        placement: "top",
                                        "popper-class": "marksPP",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "tag-content-hover" },
                                        _vm._l(_vm.marksTag, function (tag) {
                                          return _c(
                                            "span",
                                            {
                                              key: tag,
                                              class: [
                                                "tag",
                                                _vm.tagColor(row.label, tag),
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  return _vm.choiceTag(tag, row)
                                                },
                                              },
                                            },
                                            [_vm._v(" " + _vm._s(tag) + " ")]
                                          )
                                        }),
                                        0
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tag-content",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [_c("span", { staticClass: "addIcon" })]
                                      ),
                                    ]
                                  ),
                                ]
                              : [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        trigger: "hover",
                                        effect: "light",
                                        placement: "top",
                                        "popper-class": "marksPP",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "tag-content-hover" },
                                        _vm._l(_vm.marksTag, function (tag) {
                                          return _c(
                                            "span",
                                            {
                                              key: tag,
                                              class: [
                                                "tag",
                                                _vm.tagColor(row.label, tag),
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  return _vm.choiceTag(tag, row)
                                                },
                                              },
                                            },
                                            [_vm._v(" " + _vm._s(tag) + " ")]
                                          )
                                        }),
                                        0
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "tag-content",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              class: [
                                                "mTag",
                                                _vm.tagBgColor[row.label],
                                              ],
                                              attrs: {
                                                type: "theme",
                                                size: "medium",
                                                closable: "",
                                              },
                                              on: {
                                                close: function ($event) {
                                                  return _vm.closeTag(row.sid)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(row.label))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        ),
                        _vm.hasLabel(row.remark) && row.focusType == false
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "remark",
                                  on: {
                                    click: function ($event) {
                                      return _vm.remarkFocus(row, $index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "textOverflow",
                                    { attrs: { effect: "light" } },
                                    [_vm._v(_vm._s(row.remark))]
                                  ),
                                ],
                                1
                              ),
                            ]
                          : [
                              row.focusType == true && _vm.hasLabel(row.remark)
                                ? _c("el-input", {
                                    directives: [
                                      { name: "focus", rawName: "v-focus" },
                                    ],
                                    ref: "remark" + row.cid + "Input",
                                    staticClass: "marksInput",
                                    attrs: {
                                      maxlength: 30,
                                      placeholder: "请输入",
                                    },
                                    on: {
                                      focus: function ($event) {
                                        return _vm.labelFocus($event, row)
                                      },
                                      blur: function ($event) {
                                        return _vm.labelBlur($event, row)
                                      },
                                    },
                                    model: {
                                      value: row.remarkInput,
                                      callback: function ($$v) {
                                        _vm.$set(row, "remarkInput", $$v)
                                      },
                                      expression: "row.remarkInput",
                                    },
                                  })
                                : _c("el-input", {
                                    ref: "remark" + row.cid + "Input",
                                    staticClass: "marksInput",
                                    attrs: {
                                      maxlength: 30,
                                      placeholder: "请输入",
                                    },
                                    on: {
                                      focus: function ($event) {
                                        return _vm.labelFocus($event, row)
                                      },
                                      blur: function ($event) {
                                        return _vm.labelBlur($event, row)
                                      },
                                    },
                                    model: {
                                      value: row.remarkInput,
                                      callback: function ($$v) {
                                        _vm.$set(row, "remarkInput", $$v)
                                      },
                                      expression: "row.remarkInput",
                                    },
                                  }),
                            ],
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "联系方式标签",
              prop: "isFollow",
              align: "center",
              "min-width": "100",
              width: "135",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.numStatus == 5 && scope.row.isKeyContact == 1
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              "popper-class": "contact-tag",
                              effect: "light",
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "singleTag bookkeepingAgency" },
                              [_vm._v("代理记账")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "twoTag",
                                attrs: { slot: "content" },
                                slot: "content",
                              },
                              [
                                _c("span", [_vm._v("代理记账")]),
                                _c("span", [_vm._v("疑似关键联系人")]),
                              ]
                            ),
                          ]
                        )
                      : scope.row.numStatus == 5
                      ? _c(
                          "span",
                          { staticClass: "singleTag bookkeepingAgency" },
                          [_vm._v("代理记账")]
                        )
                      : scope.row.isKeyContact == 1
                      ? _c(
                          "span",
                          { staticClass: "singleTag suspectedContact" },
                          [_vm._v("疑似关键联系人")]
                        )
                      : _c("span", [_vm._v("--")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "跟进状态",
              prop: "isFollow",
              align: "center",
              width: _vm.contactNameWidthFlag ? "86" : "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class: [
                          "followStatus",
                          scope.row.isFollow == 1 ? "haveFollow" : "noFollow",
                        ],
                      },
                      [
                        _vm._v(
                          _vm._s(scope.row.isFollow == 1 ? "已跟进" : "未跟进")
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "号码状态",
              prop: "state",
              width: _vm.contactNameWidthFlag ? "86" : "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.cleaningState[scope.row.state] || "- -")
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.isTurnClue == 1 && _vm.type !== 3
                      ? _c("span", { staticClass: "mr-5" }, [_vm._v("已转化")])
                      : _vm._e(),
                    scope.row.isTurnClue != 1 &&
                    _vm.type !== 3 &&
                    _vm.NODE_ENV !== "erp-prod" &&
                    _vm.NODE_ENV !== "erp"
                      ? _c(
                          "span",
                          {
                            staticClass: "receive-btn mr-16",
                            on: {
                              click: function ($event) {
                                return _vm.clickOneReceive(scope.row, 1)
                              },
                            },
                          },
                          [_vm._v("转线索")]
                        )
                      : _vm._e(),
                    scope.row.isTurnClue != 1 &&
                    _vm.type !== 3 &&
                    (_vm.NODE_ENV == "erp-prod" || _vm.NODE_ENV == "erp")
                      ? _c(
                          "span",
                          {
                            staticClass: "receive-btn mr-16",
                            on: {
                              click: function ($event) {
                                return _vm.addCrm(scope.row, 1)
                              },
                            },
                          },
                          [_vm._v("转线索")]
                        )
                      : _vm._e(),
                    _vm.type === 3
                      ? _c("em", [
                          _c(
                            "span",
                            {
                              staticClass: "receive-btn mr-30",
                              on: {
                                click: function ($event) {
                                  return _vm.clickOneReceive(scope.row, 4)
                                },
                              },
                            },
                            [_vm._v("恢复")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "receive-btn mr-5",
                              on: {
                                click: function ($event) {
                                  return _vm.clickOneReceive(scope.row, 5)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.drawerShow !== null
        ? _c("ViewNumber", {
            ref: "vNumber",
            attrs: { show: _vm.drawerShow, companyStatus: _vm.companyStatus },
            on: {
              "update:show": function ($event) {
                _vm.drawerShow = $event
              },
            },
          })
        : _vm._e(),
      _c("erp-get-dialog", {
        ref: "erpGetDialog",
        attrs: {
          erpGetFlag: _vm.erpGetStatusFlag,
          erpbackTip: _vm.erpGetbackTip,
        },
        on: { submitCrmFormData: _vm.getCrmFormData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }